import {Nullable, PaginationType, RatingType} from "../../definitions/types";
import {RatingPaginationModel} from "../domain/ratingPaginationModel";

export class ProductRatingsModel {
    private readonly _productId: number;
    private readonly _pagination: RatingPaginationModel;

    constructor(public readonly productID: number, public readonly ratings: Nullable<RatingType>[], public readonly pageInfo: PaginationType | null) {
        this._productId = productID;
        this._pagination = new RatingPaginationModel(ratings, pageInfo);
    }

    /**
     * @method productId
     * @description Returns the product id for the ratings.
     * @returns {number}
     */
    public get productId(): number {
        return this._productId;
    }

    /**
     * @method reviewWriteUrl
     * @description Returns the url for writing a review for the product with the given id.
     * @returns {string}
     */
    public get reviewWriteUrl(): string {
        return `/Review/Write/${this._productId}`;
    }

    /**
     * @method paginationModel
     * @description Returns the pagination model, with the given variables, for the ratings.
     * @returns {RatingPaginationModel}
     */
    public get paginationModel(): RatingPaginationModel {
        return this._pagination;
    }
}